import httpClient from "../constants/http_client";
import { PEOPLE_API_CALL_HYDRATION } from "../constants/urlConstants";

export const triggerHydration = async () => {
  return httpClient.get(PEOPLE_API_CALL_HYDRATION);
};
